<template>
  <v-main class="grey lighten-4">
    <!-- Dialog de Erro -->
    <v-dialog v-model="dialogErroQuantidade" max-width="400">
      <v-card outlined>
        <v-card-title class="headline error--text">
          <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
          Erro na atualização
        </v-card-title>

        <v-card-text>
          A quantidade de vagas deve ser um valor maior ou igual a zero.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialogErroQuantidade = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card outlined class="rounded-lg mx-2">
            <!-- Cabeçalho -->
            <v-card-title >
              <v-icon left color="primary">mdi-calendar-month</v-icon>
              Gerenciamento de Serviços
            </v-card-title>

            <!-- Cards dos Dias da Semana -->
            <v-container>
              <v-row justify="center" class="mb-4">
                <v-col
                  v-for="(dia, index) in diasDaSemana"
                  :key="index"
                  cols="6"
                  sm="4"
                  md="2"
                  class="py-1 px-1"
                >
                  <v-card
                    outlined
                    hover
                    :class="{
                      'primary lighten-5 border-primary': corDoCard === index,
                      'grey lighten-4': corDoCard !== index
                    }"
                    @click="mudarTabelaPeloDia(index)"
                    class="text-center rounded-lg"
                  >
                    <v-card-text class="px-0 py-3">
                      <div class="text-subtitle-1 font-weight-medium">
                        {{ dia }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <!-- Tabela de Serviços -->
            <v-card-text>
              <v-row align="center" class="mb-4">
                <v-col cols="12" md="6">
                  <h3 class="text-h5 primary--text">
                    <v-icon left color="primary">mdi-format-list-checks</v-icon>
                    Serviços - {{ diaSemanaLista }}
                  </h3>
                </v-col>

                <v-col cols="12" md="6" class="d-flex align-center">
                  <v-spacer />
                  <v-btn
        rounded
        dark
        small
        color="secondary"
        to="adicionarPeso"
        class="mr-2"
      >
        <v-icon left>mdi-weight</v-icon>
        Adicionar peso/preferência
      </v-btn>

      <v-btn
        rounded
        dark
        small
        color="primary"
        :to="{ path: '/cadastrarServicoUnidade' }"
        class="mr-2"
      >
        <v-icon left>mdi-calendar-plus</v-icon>
        Adicionar novo serviço
      </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!listaServicosTabela.length"
                    @click="verificarQtdVagas"
                    class="mr-4"
                    depressed
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                  </v-btn>

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar serviço"
                    single-line
                    hide-details
                    outlined
                    dense
                    class="shrink"
                    style="max-width: 250px"
                  />
                </v-col>
              </v-row>

              <v-data-table
                :headers="headers"
                :items="listaServicosTabela"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [10, 15, 20],
                  'show-current-page': true
                }"
                no-data-text="Nenhum serviço cadastrado para este dia"
                class="elevation-0"
              >
                <template v-slot:item.nomeEspecialidade="{ item }">
                  <span class="font-weight-medium">{{ item.nomeEspecialidade }}</span>
                </template>

                <template v-slot:item.quantVagas="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.quantVagas"
                    large
                    @save="handleSave(item)"
                    @cancel="handleCancel(item)"
                  >
                    <v-chip
                      :color="getVagasColor(item.quantVagas)"
                      small
                      label
                    >
                      {{ item.quantVagas }}
                    </v-chip>
                    <template v-slot:input>
                      <v-text-field
                        v-model.number="item.quantVagas"
                        type="number"
                        label="Vagas disponíveis"
                        min="0"
                        outlined
                        dense
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>

                <template v-slot:item.quantVagasFixas="{ item }">
                  <v-edit-dialog
                    :return-value.sync="item.quantVagasFixas"
                    large
                    @save="handleSave(item)"
                    @cancel="handleCancel(item)"
                  >
                    <v-chip color="blue lighten-4 blue--text" small label>
                      {{ item.quantVagasFixas }}
                    </v-chip>
                    <template v-slot:input>
                      <v-text-field
                        v-model.number="item.quantVagasFixas"
                        type="number"
                        label="Vagas fixas"
                        min="0"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        v-on="on"
                        @click="alterarDadosServico(item)"
                        class="mr-2"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar serviço</span>
                  </v-tooltip>
                </template>

                <template v-slot:no-results>
                  <v-alert
                    type="info"
                    class="ma-4"
                    outlined
                  >
                    Nenhum resultado encontrado para "<strong>{{ search }}</strong>"
                  </v-alert>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import socketService from '../../../services/socket.service'
import { getToken } from '../../../store/auth'

export default {
  name: 'ServicosUnidade',

  data () {
    return {
      search: '',
      fab: true,
      dialogErroQuantidade: false,
      corDoCard: new Date().getDay(), // Dia atual como padrão
      diasDaSemana: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      diasComNome: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],

      headers: [
        { text: 'Serviço', value: 'nomeEspecialidade', align: 'start', sortable: true, width: '40%' },
        { text: 'Vagas Fixas', value: 'quantVagasFixas', align: 'center', sortable: true, width: '20%' },
        { text: 'Disponíveis', value: 'quantVagas', align: 'center', sortable: true, width: '20%' },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '20%' }
      ],

      listaServicos: [],
      listaServicosPorDia: [[], [], [], [], [], [], []],
      listaServicosTabela: [],
      user: null,
      socket: null
    }
  },

  computed: {
    diaSemanaLista () {
      return this.diasComNome[this.corDoCard]
    }
  },

  mounted () {
    this.user = this.$store.getters.usuario

    if (this.user.tipo !== 5) {
      this.$router.push('/login')
      return
    }

    this.inicializarSocket()
    this.carregarServicos()
  },

  methods: {
    getVagasColor (quantidade) {
      if (quantidade < 3) return 'red lighten-4 red--text'
      if (quantidade < 5) return 'orange lighten-4 orange--text'
      return 'green lighten-4 green--text'
    },

    async carregarServicos () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarVagaServico()
        this.listaServicos = response.data

        // Resetar arrays por dia
        this.listaServicosPorDia = [[], [], [], [], [], [], []]

        // Organizar serviços por dia
        this.listaServicos.forEach(servico => {
          if (servico.diaSemana >= 0 && servico.diaSemana <= 6) {
            servico.quantVagasInicial = servico.quantVagas
            servico.quantVagasFixasInicial = servico.quantVagasFixas
            this.listaServicosPorDia[servico.diaSemana].push(servico)
          }
        })

        // Mostrar o dia atual ou segunda-feira como padrão
        this.mudarTabelaPeloDia(this.corDoCard)
      } catch (error) {
        console.error('Erro ao carregar serviços:', error)
        this.$toast.error('Erro ao carregar serviços. Tente novamente.')
      }
    },

    mudarTabelaPeloDia (dia) {
      this.corDoCard = dia
      this.listaServicosTabela = [...this.listaServicosPorDia[dia]]
    },

    verificarQtdVagas () {
      const temErro = this.listaServicosTabela.some(
        item => item.quantVagas < 0 || item.quantVagasFixas < 0
      )

      if (temErro) {
        this.dialogErroQuantidade = true
      } else {
        this.alterarQuantidadeVagas()
      }
    },

    async alterarQuantidadeVagas () {
      const confirmacao = confirm(
        `Deseja salvar as alterações nos serviços de ${this.diaSemanaLista}?`
      )

      if (!confirmacao) return

      try {
        const servicosAlterados = this.listaServicosTabela.filter(
          item => item.quantVagas !== item.quantVagasInicial ||
                 item.quantVagasFixas !== item.quantVagasFixasInicial
        )

        if (servicosAlterados.length === 0) {
          this.$toast.info('Nenhuma alteração foi feita para salvar.')
          return
        }

        const response = await administradorUnidadeService.administradorUnidade
          .alterarQuantidadeVagas(servicosAlterados)

        if (response.data) {
          this.$toast.success('Alterações salvas com sucesso!')
          servicosAlterados.forEach(item => {
            item.quantVagasInicial = item.quantVagas
            item.quantVagasFixasInicial = item.quantVagasFixas
          })
        }
      } catch (error) {
        console.error('Erro ao atualizar vagas:', error)
        this.$toast.error('Erro ao salvar alterações. Tente novamente.')
      }
    },

    handleSave (item) {
      if (item.quantVagas < 0) item.quantVagas = 0
      if (item.quantVagasFixas < 0) item.quantVagasFixas = 0
      this.$toast.info('Alteração local salva. Clique em "Salvar" para confirmar.')
    },

    handleCancel (item) {
      item.quantVagas = item.quantVagasInicial
      item.quantVagasFixas = item.quantVagasFixasInicial
    },

    alterarDadosServico (item) {
      const diasDaSemana = this.listaServicos
        .filter(s => s.idServico === item.idServico)
        .map(s => s.diaSemana)

      this.$router.push({
        name: 'alterarDadosServico',
        params: { item, diasDaSemana }
      })
    },

    inicializarSocket () {
      this.socket = io.connect(socketService.SOCKET_URL, {
        query: { token: getToken() }
      })

      this.socket.on('novaFichaGerada', mensagem => {
        const diaAtual = new Date().getDay()
        this.listaServicosPorDia[diaAtual].forEach(servico => {
          const ficha = mensagem.find(f => f.idServico === servico.idServico)
          if (ficha) {
            servico.quantVagas--
            servico.quantVagasInicial--
          }
        })

        if (diaAtual === this.corDoCard) {
          this.listaServicosTabela = [...this.listaServicosPorDia[diaAtual]]
        }
      })
    }
  }
}
</script>

<style scoped>
/* Estilos para os cards dos dias */
.v-card--outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
}

.v-card--outlined:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.border-primary {
  border: 2px solid var(--v-primary-base) !important;
}

/* Cabeçalho do card principal */
.v-card__title.primary {
  border-radius: 8px 8px 0 0;
}

/* Estilo para a tabela */
.v-data-table {
  border-radius: 0 0 8px 8px;
}

/* Botões flutuantes */
.v-btn--floating {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-btn--floating:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.v-btn--floating.mr-3 {
  right: 5rem;
}

/* Ajustes para responsividade */
@media (max-width: 960px) {
  .v-card__title {
    flex-direction: column;
    align-items: flex-start;
  }

  .v-text-field {
    margin-top: 12px;
    width: 100%;
    max-width: 100% !important;
  }

  .v-btn--floating {
    bottom: 1rem;
    right: 1rem;
  }

  .v-btn--floating.mr-3 {
    right: 4rem;
  }
}
</style>
